var MarkerClusterer = require('./src/markerclusterer');

module.exports = MarkerClusterer;
